/* global axios */
// Aceleres: API para acoes em mensagens individuais (reacoes, pin, destaque)
// Endpoints: POST /api/v1/accounts/:accountId/aceleres/messages/:id/react|pin|star

const buildUrl = (accountId, messageId, action) =>
  `/api/v1/accounts/${accountId}/aceleres/messages/${messageId}/${action}`;

export default {
  starred(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/aceleres/starred_messages`
    );
  },
  react(accountId, messageId, emoji) {
    return axios.post(buildUrl(accountId, messageId, 'react'), { emoji });
  },
  pin(accountId, messageId) {
    return axios.post(buildUrl(accountId, messageId, 'pin'));
  },
  star(accountId, messageId) {
    return axios.post(buildUrl(accountId, messageId, 'star'));
  },
};
